module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-product"
  }, [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createMinibar($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Elige la sucursal y habitación en la que crearás el " + _vm._s(_vm.minusText))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("(Para poder seleccionar la habitación es necesario seleccionar una o todas las sucursales).")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "pt-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Sucursal",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadRooms
    },
    model: {
      value: (_vm.model.subsidiaryId),
      callback: function($$v) {
        _vm.model.subsidiaryId = $$v
      },
      expression: "model.subsidiaryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "pt-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select ml-2",
    attrs: {
      "items": _vm.rooms,
      "item-text": "codeRoom",
      "item-value": "codeRoom",
      "disabled": _vm.rooms.length === 0,
      "label": "Todas las habitaciones",
      "min-width": "198",
      "max-height": "250",
      "single-line": "",
      "required": "",
      "bottom": ""
    },
    model: {
      value: (_vm.model.externalCode),
      callback: function($$v) {
        _vm.model.externalCode = $$v
      },
      expression: "model.externalCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "pt-3": ""
    }
  }, [_c('p', {
    staticClass: "title-form mb-0"
  }, [_vm._v("Detalles del " + _vm._s(_vm.mayusText))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pt-2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": ("Nombre del " + _vm.minusText),
      "required": ""
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.model.name = $$v
      },
      expression: "model.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pt-2": "",
      "text-xs-left": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "type": "text",
      "placeholder": "Código",
      "maxlength": "10",
      "required": ""
    },
    model: {
      value: (_vm.model.code),
      callback: function($$v) {
        _vm.model.code = $$v
      },
      expression: "model.code"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("Máximo 10 caracteres")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "type": "submit",
      "disabled": !_vm.model.name || !_vm.model.code || !_vm.model.externalCode
    }
  }, [_vm._v("\n\t\t\t\tGuardar\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12d59070","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/minibar/Create.vue
// module id = 1585
// module chunks = 0